import React, {useState, useEffect} from 'react';

const Marker = (props) => {
    const wrapStyle = {
        position: 'absolute',
        width: `${props.width * props.viewHeight / 100}px`,
        top: props.value.pos_y+"%",
        left: props.value.pos_x+"%"
    };

    return (
        <div className="markerDrag" style={wrapStyle}>
            <img src={props.is_preview_marker_360 ? props.img : props.img_hover} style={{
                width:"100%",
                transform: "translate(-50%, -50%)",
            }} alt="" id={props.value.id}/>
        </div>
    )
}

export default Marker